import $ from 'jquery';

function showMessage() {
    $('.thanks-wrapper').removeClass('hide-popup').addClass('show-popup');
}

function closeMessage() {
    $('.thanks-wrapper').addClass('hide-popup').removeClass('show-popup');
}

function flashMessage(message) {
    showMessage();
    $('.thanks-text').text(message)

    setTimeout(function () {
        closeMessage();
    }, 2000);
}

$(document).ready(function () {
    const diagnosticButton = $('.get-diagnost');
    diagnosticButton.on('click', function () {
        $('.diagnostic__wrapper').removeClass('hide-popup').addClass('show-popup');
        $('body').addClass('no-over');
    });
    $('.diagnostic-content__close').on('click', function () {
        $('.diagnostic__wrapper').addClass('hide-popup').removeClass('show-popup');
        $('body').removeClass('no-over');
        $('.diagnostic-popup__name').val('');
        $('.diagnostic-popup__phone').val('');
    });
    $('.diagnostic__wrapper').click(function (event) {
        let $target = $(event.target);
        if (!$target.closest('.diagnostic').length && $('.diagnostic').is(":visible")) {
            $('.diagnostic__wrapper').addClass('hide-popup').removeClass('show-popup');
            $("body").removeClass('no-over');
            $('.diagnostic-popup__name').val('');
            $('.diagnostic-popup__phone').val('');
        }
    });
    $('.close-thanks').on('click', function () {
        closeMessage()
    })
});

export {
    flashMessage
};
